import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Email from './Email';
import Sns from './Sns';
import { UserType } from '../../types';

import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';

const TabSet = () => {
  const location = useLocation();
  const [ tabIndex, setTabIndex ] = useState(0);

  useEffect(() => {
    if (location.hash === '#donor') {
      setTabIndex(1);
    } else {
      setTabIndex(0);
    }
  }, [ location.hash ]);

  return (
    <Tabs
      className="tab_wrap_2 type"
      selectedIndex={ tabIndex }
      onSelect={ index => setTabIndex(index) }
    >
      <TabList className="tab_btnarea">
        <Tab className="tab_btn_2 pink">ドニー（女性）</Tab>
        <Tab className="tab_btn_2">ドナー（男性）</Tab>
      </TabList>

      <TabPanel className="pink">
        <div className="cont">
          <Email userType={ UserType.Donee } />
          <Sns userType={ UserType.Donee } />
        </div>
      </TabPanel>
      <TabPanel className="">
        <div className="cont">
          <Email userType={ UserType.Donor } />
          <Sns userType={ UserType.Donor } />
        </div>
      </TabPanel>
    </Tabs>
  );
}

export default TabSet;
